const state = {
  currPage: 1,
  resultCount: 0,
  pageCount: 0,
  result: [],
  noResult: false,
  query: '',
  appliedFilters: {},
  favorites: [],
  favoriteCandidates: [],
  recJobCodes: [],
  subscriptionDetail: {}
}

export default state
